<template>
  <ElDialog
    :title="$t('SETTINGS.DEVELOPERS_API.ADD_CLIENT_TITLE')"
    :visible="value"
    width="20%"
    @close="resetAndClose"
  >
    <ElForm
      ref="newClient"
      :rules="rules"
      :model="newClient"
      @submit.native.prevent="addClient"
    >
      <ElFormItem label="Redirect URI" prop="redirectURI">
        <ElInput
          v-model="newClient.redirectURI"
          type="text"
          name="redirectURI"
          dir="ltr"
          class="text-latin"
          required
          :disabled="loading"
        />
      </ElFormItem>
      <!-- dirty hack until ElementUI ends up with a solution -->
      <input v-show="false" type="submit" />
    </ElForm>

    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        :loading="loading"
        @click.native.prevent="addClient"
      >
        {{ $t('SETTINGS.DEVELOPERS_API.ADD_CLIENT_BTN') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="resetAndClose">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import { Clients } from '@/api/api';
import form from '@/mixins/form';

export default {
  name: 'AddClientModal',
  mixins: [form],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newClient: {},
      loading: false,
    };
  },
  computed: {
    rules() {
      return {
        redirectURI: {
          required: true,
          message: this.$t('VALIDATION_REQUIRED_ERR'),
          trigger: 'blur',
        },
      };
    },
  },
  methods: {
    reset() {
      this.newClient = {
        redirectURI: '',
      };
      this.$refs.newClient.resetFields();
    },
    resetAndClose() {
      this.reset();
      this.$emit('input', false);
    },
    /**
     * addClient
     *
     * takes a redirect uri and creates a new client with
     * POST request
     *
     */

    addClient() {
      if (!this.isValid('newClient')) {
        return;
      }

      this.loading = true;

      Clients.save(
        {},
        {
          redirect_uris: this.newClient.redirectURI,
        },
      )
        .then(({ body: { client } = {} }) => {
          this.$message.success(
            this.$t('SETTINGS.DEVELOPERS_API.CLIENT_CREATED'),
          );
          this.$emit('client-add', { ...client });
          this.resetAndClose();
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
